import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./bookmark-popup.m.css";
import { LoginPaymentBase } from "../../atoms/paywalls/paywall-not-logged-user/login-payment";
import { createUrl } from "../../utils/createurl";

const BookmarkPopup = ({ closePopup, feature, deleteAll, tags, stories }) => {
  const linksAccount = createUrl("createaccount");
  const [loginForm, setLoginForm] = useState(false);
  const toggleLoginForm = () => setLoginForm(true);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      closePopup();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (feature === "commenting-loggedin") {
      const timeoutId = setTimeout(() => {
        closePopup();
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [feature, closePopup]);

  const showForm = () => {
    switch (feature) {
      case "save-article":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Tallenna artikkeli</h1>
            <span styleName="text-bookmark-popup">Luo tili tai kirjaudu sisään tallentaaksesi artikkelin.</span>
          </>)
      case "save-tag":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Seuraa aihetta</h1>
            <span styleName="text-bookmark-popup">Luo tili tai kirjaudu sisään seurataksesi aiheita.</span>
          </>)
      case "delete-all-tags":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Lopeta kaikkien seuraaminen</h1>
            <span styleName="text-bookmark-popup">Haluatko varmasti lopettaa kaikkien aiheiden seuraamisen?</span>
            <div styleName="buttons-bookmark-popup">
              <div styleName="create-account-bookmark-popup" onClick={closePopup}>
                Peru
              </div>
              <div styleName="login-bookmark-popup" onClick={(e) => {
                deleteAll(e, tags);
                closePopup();
              }}>
                OK
              </div>
            </div>
          </>)
      case "delete-all-stories":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Tyhjennä lista</h1>
            <span styleName="text-bookmark-popup">Haluatko tyhjentää Tallentamani artikkelit -listan?</span>
            <div styleName="buttons-bookmark-popup">
              <div styleName="create-account-bookmark-popup" onClick={closePopup}>
                Peru
              </div>
              <div styleName="login-bookmark-popup" onClick={(e) => {
                deleteAll(e, stories);
                closePopup();
              }}>
                OK
              </div>
            </div>
          </>)
      case "commenting":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Osallistu keskusteluun</h1>
            <span styleName="text-bookmark-popup">Kirjaudu sisään osallistuaksesi keskusteluun.</span>
          </>)
      case "commenting-loggedin":
        return (
          <>
            <h1 styleName="heading-bookmark-popup">Osallistu keskusteluun</h1>
            <span styleName="text-bookmark-popup">Liity keskusteluun painamalla "Aloita keskustelu" -painiketta.</span>
          </>)
      default:
        break;
    }
  }

  return (
    <div styleName="bookmark-popup-container">
      <div styleName="bookmark-popup-body" ref={ref}>
        <div styleName="close-bookmark-popup" onClick={closePopup}>
          <i className="ri-close-line" />
        </div>
        {!loginForm && (
          showForm())}
        {(!loginForm && feature != "delete-all-tags" && feature != "delete-all-stories" && feature != "commenting-loggedin") &&
          <div styleName="buttons-bookmark-popup">
            <a styleName="create-account-bookmark-popup" className="create-account-bookmark-popup" href={linksAccount}>
              Luo tili
            </a>
            <div styleName="login-bookmark-popup" className="login-bookmark-popup" onClick={() => toggleLoginForm()}>
              Kirjaudu
            </div>
          </div>
        }

        {(loginForm) && <LoginPaymentBase />}
      </div>
    </div>
  );
};

BookmarkPopup.propTypes = {
  element: PropTypes.object,
  goNext: PropTypes.func,
  goPrev: PropTypes.func,
  hideNext: PropTypes.number,
  index: PropTypes.number,
  closePopup: PropTypes.func
};

export default BookmarkPopup;
